<template>
  <form :id="id" action="#" @submit.prevent="handleSubmit($event)">
    <slot v-if="status === 'idle'" />
    <div v-else-if="status === 'loading'">
      <div class="spinner" />
    </div>
    <slot name="success" v-else-if="status === 'success'" :response="response" />
    <slot name="error" v-else-if="status === 'error'" :response="response" />
  </form>
</template>

<script>
let ids = 0;
const serializeForm = form => {
  const formData = new FormData(form);
  let json = {};
  formData.forEach((value, key) => {
    if (!Object.prototype.hasOwnProperty.call(json, key)) {
      json[key] = value;
      return;
    }

    if (!Array.isArray(json[key])) {
      json[key] = [json[key]];
    }

    json[key].push(value);
  });

  return json;
};

export default {
  name: 'SloForm',
  props: {
    endpoint: {type: String, required: true},
    resetScrollOnSubmit: {type: Boolean, default: false}
  },
  data() {
    const scrollContainer = window;

    return {
      scrollContainer,
      id: `slo-form-${ids++}`,
      status: 'idle',
      response: null
    };
  },
  methods: {
    async handleSubmit(event) {
      this.status = 'loading';
      const form = serializeForm(event.target);
      if (this.resetScrollOnSubmit) this.scrollIntoView();
      try {
        const res = await fetch(this.endpoint, {
          method: 'POST',
          body: JSON.stringify(form)
        }).then(res => res.json());
        this.status = 'success';
        this.response = res;
      } catch (e) {
        this.status = 'error';
        this.response = e;
      }
    },
    scrollIntoView() {
      try {
        this.scrollContainer.scrollTo(0, 0);
      } catch (e) { // eslint-disable-line
      }
    }
  }
};
</script>
